import { gql, useMutation } from '@apollo/client';
//devolver DTO
export const USER_CHANGE_PASSWORD_CURRENT = gql`
  mutation UserChangePasswordCurrent($pwdRepeat: String, $pwd: String) {
    user_changePassword_current(pwdRepeat: $pwdRepeat, pwd: $pwd) {
      username
    }
  }
`;
export const useUserChangePasswordCurrent = onCompleteQuery => {
  return useMutation(USER_CHANGE_PASSWORD_CURRENT, {
    errorPolicy: 'all',
    onCompleted({}) {
      if (onCompleteQuery) {
        onCompleteQuery();
      }
    }
  });
};